'use strict'
// import './style/mobile.styl' // 移动端适配
import './iconfont/iconfont.css' // 引入iconfont
const requireComponent = require.context('./components', true, /index.vue$/)

const install = function (Vue, options = {}) {
  requireComponent.keys().forEach(fileName => {
    // 防止在加载@ccms包时又注册一次
    if (fileName && typeof fileName === 'string' && fileName.indexOf('@ccms') > -1) {
      return false
    }
    const config = requireComponent(fileName)
    const componentName = changeStr(
      fileName.replace(/^\.\//, '').replace(/\.\w+$/, '').split('/')[0]
    )
    // 动态注册该目录下的所有.vue文件
    Vue.component(componentName, config.default || config)
  })
}

// 小写转大写
function changeStr (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export {
  install
}
export default {
  install
}